import React from 'react'
import { css } from '@emotion/core'
import { Button, IconButton } from '@fs/zion-ui'
import { useTranslation } from 'react-i18next'
import { LogoFacebook, LogoInstagram, LogoTwitter } from '@fs/zion-ui/dist/es/social-share/assets/index'
import LogoYoutube from './LogoYoutube'
import LogoLinkedin from './LogoLinkedin'

const socialOverrideCss = css`
  & svg,
  & > button,
  & > a {
    color: white !important;
    margin-right: 4px;
    margin-left: 4px;
  }
  & > button,
  & > a {
    transform: translateX(-12px);
    text-transform: initial !important;
    letter-spacing: 0.035em !important;
    padding-right: 8px;
  }
`

const iconMap = {
  linkedin: LogoLinkedin,
  facebook: LogoFacebook,
  instagram: LogoInstagram,
  twitter: LogoTwitter,
  youtube: LogoYoutube,
}
const getIcon = (platform) => {
  const name = platform.toLowerCase()
  return iconMap[name]
}

export default function SocialButton({ isMobile, platform, children, ...props }) {
  const [t] = useTranslation()
  const ButtonComponent = isMobile ? IconButton : Button
  return (
    <div css={socialOverrideCss}>
      <ButtonComponent data-testid="social-share" {...props} Icon={getIcon(platform)}>
        {platform ? t(`social-share.${platform}`, platform.toUpperCase()) : children}
      </ButtonComponent>
    </div>
  )
}
